
import { useState, useEffect, useRef } from 'react';

const useFetch = (url, options = {}) => {
  const [data, setData] = useState(null);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);
  const cache = useRef({});

  // 默认配置
  const defaultOptions = {
    method: 'GET',
    ...options
  };

  useEffect(() => {
    let isMounted = true;
    const abortController = new AbortController();

    const fetchData = async () => {
      try {
        // 检查缓存
        if (cache.current[url]) {
          if (isMounted) {
            setData(cache.current[url]);
            setLoading(false);
          }
          return;
        }

        setLoading(true);
        const response = await fetch(url, {
          ...defaultOptions,
          signal: abortController.signal
        });

        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }

        const result = await response.json();
        
        // 更新缓存
        cache.current[url] = result;

        if (isMounted) {
          setData(result);
          setLoading(false);
        }
      } catch (err) {
        if (err.name !== 'AbortError' && isMounted) {
          setError(err.message);
          setLoading(false);
        }
      }
    };

    fetchData();

    return () => {
      isMounted = false;
      abortController.abort();
    };
  }, [url]);

  return { data, error, loading };
};

export default useFetch;